// MultiStepForm.js
import React, { useEffect, useState } from "react";
import { useRef } from "react";
import {
  Container,
  Form,
  Button,
  ProgressBar,
  Nav,
  Alert,
} from "react-bootstrap";
import SignaturePad from "react-signature-canvas"; // Import the SignaturePad component
import "./Signature.css";
import { getSasToken } from "../../store/thunk/user";
import { connect } from "react-redux";
import { updateForm } from "../../utils/updateForm";
import { uploadDocumentAndGetUrl } from "../../utils/uploadDocument";
import { dataURLtoBlob } from "../../utils/dataURLtoBlob";
import { toast } from "react-toastify";
import { triggerButtonClick } from "../../utils/triggerLibraryButton";
import LfukRecruitmentServicesLimitedTermsOfEngagementDownload from "./Download/LfukRecruitmentServicesLimitedTermsOfEngagementDownload";
import moment from "moment";
import { Tabs, Tab, Box } from "@mui/material";

const LfukRecruitmentServicesLimitedTermsOfEngagement = ({
  currentDocument,
  documentList,
  user,
  sasToken,
  ipAddress,
  getSasToken,
}) => {
  const [step, setStep] = useState(1);
  const [progress, setProgress] = useState(0); // Progress percentage for each step
  const [value, setValue] = useState(0);
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };
  const [formData, setFormData] = useState({
    title: "",
    firstName: "",
    surName: "",
    documentSignature: "",
    signedDate: moment(new Date()).format("DD-MM-YYYY"),
    typeOfWork: "",
    consent: false,
    signature: "", // Store the signature data as a string
  });
  const [errors, setErrors] = useState({});
  const sigPadRef = useRef(null); // Reference to the SignaturePad component
  const documentSigPadRef = useRef(null); // Reference to the SignaturePad component
  useEffect(() => {
    setFormData(currentDocument);
    if (currentDocument?.step) {
      setStep(currentDocument?.step);
    }
    if (currentDocument?.progress) {
      setProgress(currentDocument?.progress);
    }
    if (currentDocument?.progress === 100) {
      getSasToken();
    }
  }, []);
  // Function to handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
    setErrors({ ...errors, [name]: "" });
  };

  // Function to validate each step
  const validateStep = () => {
    let formErrors = {};
    if (step === 1) {
      if (!formData.title) formErrors.title = "This field is required";
      if (!formData.firstName) formErrors.firstName = "This field is required";
      if (!formData.surName) formErrors.surName = "This field is required";
      if (!formData.typeOfWork)
        formErrors.typeOfWork = "This field is required";
      if (documentSigPadRef.current.isEmpty()) {
        formErrors.documentSignature = "This field is required"; // Check if the signature pad is empty
      }
    } else if (step === 2) {
      if (!formData.consent) formErrors.consent = "You must agree to the terms";
      if (sigPadRef.current.isEmpty())
        formErrors.signature = "Signature is required"; // Check if the signature pad is empty
    }
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  // Function to go to the next step
  const nextStep = async () => {
    if (validateStep()) {
      const documentSignatureImage = documentSigPadRef.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
      const signatureBlob = dataURLtoBlob(documentSignatureImage);
      // Create a FormData object
      const formDataSign = new FormData();
      // Append the Blob as a file to the FormData
      // The second argument is the file name, which you can customize as needed
      formDataSign.append(
        "file",
        signatureBlob,
        `${[currentDocument["key"]]}.png`
      );
      // Send the FormData using postMultiPartFormData
      const documentUrl =
        (await uploadDocumentAndGetUrl(formDataSign, user?.token)) || "";
      if (documentUrl) {
        const payload = {
          [currentDocument["key"]]: {
            name: currentDocument?.name,
            ...formData,
            documentSignature: documentUrl,
            progress: progress + 50,
            step: step + 1,
          },
        };
        updateForm(payload, documentList, user);
        setStep(step + 1);
        setProgress(progress + 50);
      } else {
        toast.error(
          "Something went wrong while upload signature. please try again."
        );
      }
    }
  };

  // Function to go to the previous step
  const prevStep = () => {
    setStep(step - 1);
    setProgress(progress - 50);
  };

  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateStep()) {
      // Get the signature data as a base64 image
      const signatureImage = sigPadRef.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
      setFormData({
        ...formData,
        signature: signatureImage,
      });
      const signatureBlob = dataURLtoBlob(signatureImage);
      // Create a FormData object
      const formDataSign = new FormData();
      // Append the Blob as a file to the FormData
      // The second argument is the file name, which you can customize as needed
      formDataSign.append(
        "file",
        signatureBlob,
        `${[currentDocument["key"]]}.png`
      );
      // Send the FormData using postMultiPartFormData
      const documentUrl =
        (await uploadDocumentAndGetUrl(formDataSign, user?.token)) || "";
      if (documentUrl) {
        const payload = {
          [currentDocument["key"]]: {
            name: currentDocument?.name,
            ...formData,
            progress: 100,
            step: step,
            signature: documentUrl,
            signDate: new Date(),
            ipAddress: ipAddress,
          },
        };
        updateForm(payload, documentList, user);
        toast.success("Successfully filled the form.");
        triggerButtonClick();
      } else {
        toast.error(
          "Something went wrong while upload signature. please try again."
        );
      }
      // Additional submit logic here, such as sending formData to the server
    }
  };
  // Clear the signature pad
  const clearSignature = () => {
    sigPadRef.current.clear();
    setFormData({ ...formData, signature: "" });
  };
  // Clear the signature pad
  const clearDocumentSignature = () => {
    documentSigPadRef.current.clear();
    setFormData({ ...formData, documentSignature: "" });
  };
  return (
    <Container className="mt-5">
      {currentDocument?.progress === 100 ? (
        <>
          <LfukRecruitmentServicesLimitedTermsOfEngagementDownload
            data={currentDocument}
            sasToken={sasToken}
            user={documentList?.userDetail}
          />
          <Box sx={{ width: "100%" }}>
            <Tabs
              value={value}
              onChange={handleTabChange}
              aria-label="Personal Information"
              className="tab mt-2"
            >
              <Tab label="Personal Information" />
            </Tabs>
            {value === 0 && (
              <div className="container">
                <div className="row">
                  <h2>Personal Information</h2>
                  <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between">
                      <strong>Title</strong>{" "}
                      <span>{currentDocument?.title || "--"}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between">
                      <strong>First Name</strong>{" "}
                      <span>{currentDocument?.firstName || "--"}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between">
                      <strong>Surname</strong>{" "}
                      <span>{currentDocument?.surName || "--"}</span>
                    </li>
                    <li
                      class="list-group-item d-flex"
                      style={{ textAlign: "justify" }}
                    >
                      <strong>
                      TERMS OF ENGAGEMENT FOR TEMPORARY AGENCY WORKERS (Contract for
                  Services) AGENCY WORKER NAME IN FULL: TYPE OF WORK TO BE
                  PROVIDED: 1. DEFINITIONS 1.1 In these Terms of Engagement, the
                  following definitions apply: “Agency Worker” means the person
                  named above; “Assignment” means the period during which the
                  Agency Worker is supplied to provide services to the Client.
                  Each Assignment will end when the Agency Worker ceases to be
                  supplied to the Client or when the Agency Worker is no longer
                  available for work; “Assignment Schedule” means written
                  confirmation of the assignment details to be given to the
                  Agency Worker upon acceptance of the Assignment; “AWR” means
                  the Agency Workers Regulations 2010; “Client” means the
                  person, firm, or corporate body together with any subsidiary
                  or associated person, firm, or corporate body (as the case may
                  be) to whom or which the Agency Worker is supplied or
                  introduced; “Conduct Regulations” means the Conduct of
                  Employment Agencies and Employment Businesses Regulations
                  2003; “Confidential Information” means any and all
                  confidential commercial, financial, marketing, technical or
                  other information or data of whatever nature relating to the
                  Client or Employment Business or their business or affairs
                  (including but not limited to these Terms; data, records,
                  reports, agreements, software, programs, specifications,
                  knowhow, trade secrets and other information concerning the
                  Assignment) in any form or medium whether disclosed or granted
                  access to whether in writing, orally or by any other means,
                  provided to the Agency Worker or any third party in relation
                  to the Assignment by the Client or the Employment Business or
                  by a third party on behalf of the Client whether before or
                  after the date of these Terms together with any reproductions
                  of such information in any form or medium or any part(s) of
                  such information; “Employment Business” means Rapid Resourcing LTD registered in the UK under registration
                  number 05757489 whose registered office is at C/O Henry
                  Diaper, Lees Road, Knowsley Industrial Park, Liverpool,
                  Merseyside, L33 7SE; “Relevant Period” means the later of: (a)
                  the period of eight weeks commencing on the day after the last
                  day on which the Agency Worker worked for the Client having
                  been supplied by the Employment Business; or (b) the period of
                  fourteen weeks commencing on the first day on which the Agency
                  Worker worked for the Client having been supplied by the
                  Employment Business; or (c) Fourteen weeks from the first day
                  of the most recent Assignment where there has been a break of
                  more than six weeks (forty-two days) since any previous
                  Assignment; “Terms” means the terms and conditions set out
                  herein together with any Assignment Schedule to these Terms.
                  1.2 Unless the context otherwise requires, references to the
                  singular include the plural and references to the masculine
                  include the feminine and vice versa. 1.3 The headings
                  contained in these Terms are for convenience only and do not
                  affect their interpretation. 2. THE CONTRACT 2.1 These Terms
                  constitute a Contract for Services between the Employment
                  Business and the Agency Worker, and they govern all
                  Assignments undertaken by the Agency Worker. No Contract shall
                  exist between the Employment Business and the Agency Worker
                  between Assignments. These Terms shall prevail over any other
                  Terms put forward by the Agency Worker. 2.2 For the avoidance
                  of doubt, the Agency Worker is not an employee of the
                  Employment Business although the Employment Business is
                  required to make deductions from the Agency Worker's pay in
                  accordance with Clause 7.1. These Terms shall not give rise to
                  a Contract of Employment between the Employment Business and
                  the Agency Worker, or the Agency Worker and the Client. The
                  Agency Worker is supplied as a Worker, and is entitled to
                  certain statutory rights as such, but nothing in these Terms
                  shall be construed as giving the Agency Worker rights in
                  addition to those provided by statute except where expressly
                  stated. 2.3 No variation or alteration of these Terms shall be
                  valid unless approved by the Employment Business in writing
                  and signed by both parties. 2.4 The Employment Business shall
                  act as an Employment Business (as defined in Section 13(3) of
                  the Employment Agencies Act 1973) (as amended) when
                  introducing or supplying the Agency Worker for Assignments
                  with its Clients. 3. ASSIGNMENTS 3.1 The Employment Business
                  will endeavour to obtain suitable Assignments for the Agency
                  Worker in the capacity detailed above. 3.2 The Agency Worker
                  shall not be obliged to accept any Assignment offered by the
                  Employment Business, and the Employment Business shall incur
                  no liability to the Agency Worker should it fail to offer
                  opportunities to work in the capacity detailed above or in any
                  other capacity. 3.3 The Agency Worker acknowledges that the
                  nature of temporary work means that there may be periods when
                  no suitable work is available and agrees that suitability
                  shall be determined solely by the Employment Business. 3.4 The
                  Agency Worker is free to engage in other work, however if they
                  have already carried out or are considering any additional
                  work, they should notify the Employment Business so that any
                  implications arising from the current Working Time Legislation
                  can be discussed. 3.5 For the purpose of calculating the
                  average number of weekly hours worked by the Agency Worker on
                  an Assignment, the start date for the relevant averaging
                  period under the Working Time Regulations 1998 shall be the
                  date on which the Agency Worker commences the first
                  Assignment. 3.6 If during the course of an Assignment or
                  during the Relevant Period at the end of an Assignment the
                  Client wishes to employ the Agency Worker direct, the Agency
                  Worker acknowledges that the Employment Business will be
                  entitled either to charge the Client an introduction fee or to
                  agree an extension of the hiring period with the Client at the
                  end of which the Agency Worker may be employed direct by the
                  Client without further charge. 4. EMPLOYMENT BUSINESS
                  OBLIGATIONS 4.1 At the same time as an Assignment is offered
                  to the Agency Worker, which may be on an hourly, daily,
                  weekly, or other basis, the Employment Business shall inform
                  the Agency Worker of the identity of the Client and if
                  applicable, the nature of their business; the date the work is
                  to commence and the duration or likely duration of the work;
                  the type of work, location and hours during which the Agency
                  Worker would be required to work; the rate of remuneration
                  that will be paid and any expenses payable by or to the Agency
                  Worker; and any risks to health and safety known to the Client
                  in relation to the Assignment and the steps the Client has
                  taken to prevent or control such risks. In addition, the
                  Employment Business shall inform the Agency Worker what
                  experience, training, and qualifications the Client considers
                  necessary to work on the Assignment and of any authorisation
                  required by law or a professional body to work on the
                  Assignment. 4.2 Where such information is not given in paper
                  form or by electronic means it shall be confirmed by such
                  means by the end of the third business day following
                  (excluding Saturday, Sunday and any public or Bank Holidays).
                  4.3 If a variation to the Assignment Schedule is agreed
                  between the Agency Worker and the Employment Business, the
                  Agency Worker shall be provided with a copy of the Assignment
                  Schedule confirming the agreed variation by no later than five
                  business days following the day on which the variation was
                  agreed. 4.4 An Assignment Schedule may not be provided by the
                  Employment Business to the Agency Worker under the following
                  circumstances: (a) Where the Agency Worker is being offered an
                  Assignment in the same position that they have undertaken
                  within the previous five working days and the Assignment
                  Schedule has already been provided to the Agency Worker; or
                  (b) Where the Assignment is intended to last for five
                  consecutive working days or less and the Agency Worker has
                  previously received the Assignment Schedule on which the
                  details remain the same. In such situation the Employment
                  Business need only provide written confirmation of the
                  identity of the Client and the likely duration of the
                  Assignment. Where the Assignment subsequently extends past the
                  five working days, the Agency Worker shall be provided with an
                  Assignment Schedule within eight days from the start of the
                  Assignment. 4.5 The Employment Business will ensure that the
                  Agency Worker receives any rights in relation to basic
                  employment and working conditions to which they are entitled
                  to under Regulation 5 of the AWR once the Agency Worker has
                  completed the qualifying period (currently the Agency Worker
                  must work in the same role with the same Client for twelve
                  continuous calendar weeks, during one or more Assignments).
                  4.6 In accordance with Regulation 12 of the AWR, the
                  Employment Business will ensure that unless less favourable
                  treatment is justified on objective grounds, the Agency Worker
                  is treated no less favourably than a comparable worker in
                  relation to the collective facilities and amenities (which are
                  defined as canteen or other similar facilities, child care
                  facilities and transport services) provided by the Client. 4.7
                  In accordance with Regulation 13 of the AWR, the Employment
                  Business will ensure that during the Assignment the Agency
                  Worker is informed of any relevant vacant posts with the
                  Client to give the Agency Worker the same opportunity as a
                  comparable worker to find permanent employment with the
                  Client. 5. AGENCY WORKERS OBLIGATIONS 5.1 The Agency Worker
                  shall during every Assignment and afterwards where
                  appropriate: (a) Co-operate with the Client's reasonable
                  instructions and accept the direction and supervision of any
                  responsible person in the Client’s organisation; (b) Make
                  themselves available to the Client for no less than the
                  minimum working hours (the Assignment Work Pattern), shown on
                  the provided Assignment Schedule; (c) Familiarise themself
                  with and observe any relevant rules and regulations of the
                  Client's establishment to which attention has been drawn or
                  which the Agency Worker might reasonably be expected to
                  ascertain (including but not limited to rules surrounding
                  normal hours of work and the use of any computer equipment,
                  Client telephones and personal mobile phones); (d) Take all
                  reasonable steps to safeguard their own health and safety and
                  that of any other person who may be present or be affected by
                  their actions on the Assignment and comply with the Health and
                  Safety policies and procedures of the Client; (e) Report any
                  accident or incident that occurs whilst on an Assignment to
                  the Client and ensure that it is entered into the Client’s
                  Accident Book; (f) Not operate any vehicle, plant, or
                  machinery without prior agreement between and subsequent
                  authorisation from the Employment Business and the Client; (g)
                  Not engage in any conduct detrimental to the interests of the
                  Client or the Employment Business including any conduct from
                  the Agency Worker reasonably likely to be detrimental to the
                  Client's custom or business and their reputation; (h) Conduct
                  themselves in a professional manner and dress according to
                  Client requirements. Where no specific instructions have been
                  given, a professional image should be maintained and clothes
                  appropriate to the responsibilities of the Assignment worn
                  along with any form of identification required. All applicable
                  laws in this respect need to be abided by; (i) At the end of
                  the Assignment or when directed, return to the Employment
                  Business, all property of the Employment Business or Client
                  including but not limited to all equipment, materials,
                  documents, personal protective equipment, clothing, and safety
                  boots; (j) Not at any time divulge to any person, nor use for
                  their own or any other person's benefit, any Confidential
                  Information relating to the Client's or the Employment
                  Businesses' employees, customers, business affairs,
                  transactions, or finances. 5.2 If the Agency Worker is unable
                  for any reason to attend work during an Assignment, they
                  should inform the Employment Business at the first possible
                  opportunity, but in any event at least two hours prior to the
                  commencement of the Assignment or shift. Where contact to the
                  Employment Business is not possible the Agency Worker is
                  required to contact the Client. 5.3 Where the Agency Worker
                  becomes aware of any reason why they may not be suitable for
                  an Assignment either before the commencement of or during the
                  Assignment they should notify the Employment Business
                  immediately. 5.4 By commencing an Assignment, the Agency
                  Worker acknowledges that they are not aware of anything which
                  will cause a detriment to the Employment Business and/or the
                  interests of the Client by being engaged in such an
                  Assignment. The Agency Worker shall inform the Employment
                  Business immediately if they become aware of any circumstances
                  which might affect the Client's willingness to accept their
                  services. 5.5 The Agency Worker warrants that all information
                  provided to the Employment Business in regard to their right
                  to work in the UK, experience, training and qualifications,
                  which may be required or considered by any professional body
                  when determining whether to engage the Agency Workers
                  services, or which are required by law, is true and compliant.
                  5.6 Prior to the commencement of the Assignment, the Agency
                  Worker shall notify the Employment Business if the Client is a
                  previous employer whether this be directly or via another
                  Employment Business or third party and will provide details of
                  when and in what role(s), including details of any breaks
                  between periods of work, and the reasons for such breaks. 5.7
                  If the Agency Worker considers that they have not or may not
                  have received equal treatment under the AWR, the Agency Worker
                  should discuss this with the Employment Business or raise this
                  in writing with the Employment Business setting out as fully
                  as possible the basis of their concerns. 5.8 The Agency Worker
                  acknowledges that any breach of their obligations under this
                  Clause may cause the Employment Business to suffer loss and
                  they agree that the Employment Business reserves the right to
                  make a claim for damages to recover such losses from the
                  Agency Worker. 6. TIMESHEETS 6.1 At the end of each week of an
                  Assignment (or at the end of the Assignment where it is for a
                  period of one week or less or is completed before the end of a
                  week) the Agency Worker shall deliver to the Employment
                  Business their time sheet duly completed to indicate the
                  number of hours worked by them during the preceding week (or
                  such lesser period) and signed by an authorised representative
                  of the Client. 6.2 Subject to Clause 6.3 the Employment
                  Business shall pay the Agency Worker for all hours worked
                  regardless of whether the Employment Business has received
                  payment from the Client for these hours. 6.3 Failure to submit
                  a properly completed or authorised timesheet for hours worked
                  may delay payment for those hours. 6.4 Deliberate
                  misrepresentation by an Agency Worker on a timesheet of the
                  hours worked, if proven following investigation, will be
                  handled as fraud. 6.5 For the avoidance of doubt and for the
                  purposes of the Working Time Regulations 1998, the Agency
                  Worker's working time shall only consist of those periods
                  during which they are carrying out their activities or duties
                  for the Client as part of the Assignment. Subject to any
                  amendments made to the Agency Worker's basic working
                  conditions during the term of this Agreement in compliance
                  with Regulation 5 of the AWR, time spent travelling to the
                  Client's premises, lunch breaks and other rest breaks shall
                  not count as part of the Agency Worker's working time for
                  these purposes. 7. REMUNERATION 7.1 The Employment Business
                  shall pay to the Agency Worker remuneration of the current
                  National Minimum Wage or National Living Wage (where
                  applicable), or above. The actual rate will be notified on a
                  per Assignment basis, for each hour worked during an
                  Assignment, subject to deductions in respect of PAYE pursuant
                  to Section 44-47 of the Income Tax (Earnings and Pensions) Act
                  2003 and Class 1 National Insurance Contributions and any
                  other deductions which the Employment Business may be required
                  by law to make. 7.2 Payment will be made weekly in arrears
                  directly into the Agency Workers nominated bank account on
                  Friday of each week in respect of the hours worked in the
                  preceding week. Any queries regarding payment should be raised
                  with the Employment Business. 7.3 The Agency Worker may by
                  virtue of having completed the qualifying period for an
                  Assignment be entitled under the AWR to an increase in their
                  pay and other benefits and any such variation will be notified
                  to the Agency Worker in the Assignment Schedule. 7.4 Subject
                  to any statutory entitlement under the relevant legislation
                  referred to in Clauses 8 and 9 below and any other statutory
                  requirement, the Agency Worker is not entitled to receive
                  payment from the Employment Business or Client for time not
                  spent on Assignment, whether in respect of holidays, illness
                  or absence for any other reason, unless otherwise agreed. 7.5
                  Subject to compliance with Regulation 12 of the Conduct
                  Regulations, the Employment Business reserves the right in its
                  absolute discretion to deduct from the Agency Worker’s pay any
                  sums which they may owe the Employment Business including,
                  without limitation, any overpayments, loans or advances made
                  to the Agency Worker by the Employment Business or any losses
                  suffered by the Employment Business as a result of the Agency
                  Workers negligence or breach of either the Employment
                  Business’s or the Client’s rules. If the Agency Worker’s final
                  payment is insufficient to allow for the whole amount of any
                  deduction, they will be required to repay any outstanding
                  amount due to the Employment Business within the terms agreed.
                  7.6 The Employment Business reserves the right to deduct the
                  cost of any speeding or parking fines from the Agency Workers
                  remuneration if it can be proved that they were allocated the
                  vehicle when the fine was incurred. 8. STATUTORY LEAVE 8.1
                  Subject to any increased entitlement pursuant to the AWR, the
                  Agency Worker is entitled to paid annual leave for time worked
                  during an Assignment according to the statutory minimum as
                  amended occasionally. 8.2 The current statutory minimum
                  entitlement to paid annual leave is 5.6 weeks inclusive of
                  Bank Holidays. All entitlement to leave must be taken during
                  the Leave Year in which it accrues, and none may be carried
                  forward to the next year. 8.3 Under the AWR, on completion of
                  the qualifying period the Agency Worker may be entitled to
                  paid and/or unpaid annual leave in addition to the Agency
                  Worker's entitlement to paid annual leave under the Working
                  Time Regulations and in accordance with Clauses 8.1 and 8.2.
                  If this is the case, any such entitlement(s), the date from
                  which any such entitlement(s) will commence and how payment
                  for such entitlement(s) accrue will be set out in the relevant
                  Assignment Schedule. 8.4 The Leave Year is the annual period
                  during which the Agency Worker accrues and may take statutory
                  leave and runs from 01 January to 31 December. The Agency
                  Worker is responsible for ensuring that all paid annual leave
                  is requested and taken within the Leave Year. 8.5 Entitlement
                  to payment for leave accrues in proportion to the amount of
                  time worked continuously by the Agency Worker on Assignment
                  during the Leave Year and is paid in accordance with the
                  Working Time Regulations. Annual leave does not accrue for any
                  time when the Agency Worker is not working on Assignment. 8.6
                  Subject to Clause 8.3, the amount of payment which the Agency
                  Worker will receive in respect of periods of annual leave
                  taken during the course of an Assignment will be calculated in
                  accordance with and paid in proportion to the number of days
                  which the Agency Worker has worked on Assignment. 8.7 Subject
                  to Clause 8.3, in the course of any Assignment during the
                  first Leave Year, the Agency Worker is entitled to request and
                  receive paid leave at the rate of one-twelfth of the Agency
                  Worker's total holiday entitlement in each month of the Leave
                  Year. 8.8 Where the Agency Worker wishes to take any leave to
                  which they are entitled, they should put the request in
                  writing to admin@rapidresourcingltd.co.uk advising of the dates
                  of their intended absence. The amount of notice, which the
                  Agency Worker is required to give, is a minimum of four weeks
                  to take a weeks’ holiday or a minimum of one week to take a
                  single day. The Agency Worker should also notify the Client of
                  their intended absence. 8.9 The Employment Business will
                  allocate agreed leave dates to take account of business needs
                  and the arrangements made by other Agency Workers and or
                  Clients own employees to ensure operational efficiency. The
                  Employment Business reserves the right to refuse leave
                  requests if they conflict with the needs of the business and
                  may, with due notice, require that the Agency Worker takes
                  their annual leave on specified dates. 8.10 Where a Bank
                  Holiday or other public holiday falls during an Assignment and
                  the Agency Worker does not work on that day, the day may be
                  taken as part of the Agency Worker's paid annual leave
                  entitlement. 8.11 Where this Contract is terminated by either
                  party and a P45 is requested, the Agency Worker shall be
                  entitled to a payment in lieu of any untaken leave where the
                  amount of leave taken is less than the amount accrued in
                  accordance with Clause 8.5 above. Where the Agency Worker has
                  taken more leave than has been accrued pro-rata, the
                  appropriate deductions will be made from their final payment.
                  9. SICKNESS ABSENCE 9.1 The Agency Worker may be eligible for
                  Statutory Sick Pay if they meet the relevant statutory
                  criteria. 9.2 The Agency Worker is required to provide
                  evidence of incapacity to work to the Employment Business, by
                  way of a self-certification form for the first seven days of
                  incapacity and a doctor's/hospital certificate thereafter. 9.3
                  For the purposes of the Statutory Sick Pay scheme the
                  qualifying days for entitlement to payment are the days on
                  which the Agency Worker is due to work on an Assignment. There
                  will be no entitlement to Statutory Sick Pay when the Agency
                  Worker was not due to work on Assignment. Statutory Sick Pay
                  is not payable for the first three qualifying days in a period
                  of incapacity for work. 9.4 In the event that the Agency
                  Worker submits a Statement of Fitness for Work or similar
                  medical evidence, which indicates that the Agency Worker may,
                  subject to certain conditions be fit to work/return to work,
                  the Employment Business will in its absolute discretion
                  determine whether the Agency Worker will be: (a) placed in a
                  new Assignment; or (b) permitted to continue with the ongoing
                  Assignment. In making such determination, the Employment
                  Business may consult with the Client and Agency Worker as
                  appropriate to assess whether the conditions identified in the
                  Statement or similar documentation can be satisfied for the
                  duration of the Assignment. 10. PENSION 10.1 The Employment
                  Business will comply with the pension duties in respect of the
                  Agency Worker in accordance with Part 1 of the Pensions Act
                  2008. 11. TERMINATION 11.1 The Employment Business or the
                  Client may terminate the Agency Workers Assignment at any time
                  without prior notice or liability. 11.2 The Agency Worker is
                  required to give one weeks’ notice to terminate an Assignment
                  to enable a replacement to be found (unless the Assignment is
                  for a shorter period, in which case the Agency Worker must
                  work to the end of the agreed Assignment period). 11.3
                  Continuation of an Assignment is subject to continuation of
                  the Contract between the Employment Business and the Client.
                  In the event that this is terminated for any reason, the
                  Assignment will cease with immediate effect without liability
                  to the Agency Worker, with the exception of hours worked by
                  the Agency Worker up to the date of termination of the
                  Assignment. 11.4 If the Agency Worker does not inform the
                  Client or the Employment Business (in accordance with Clause
                  5.2) should they be unable to attend work during the course of
                  an Assignment this will be treated as termination of the
                  Assignment by the Agency Worker in accordance with Clause 11.2
                  unless the Agency Worker can show that exceptional
                  circumstances prevented them from complying with Clause 5.2.
                  11.5 If the Agency Worker is absent during the course of an
                  Assignment and the Contract has not been otherwise terminated,
                  the Employment Business will be entitled to terminate the
                  Contract in accordance with Clause 11.1 if the work to which
                  the Agency Worker was assigned is no longer available. 11.6 If
                  the Agency Worker does not report to the Employment Business
                  to notify their availability for work for a period of three
                  weeks, the Employment Business will forward their P45 to their
                  last known address. 12. EQUAL OPPORTUNITIES 12.1 The
                  Employment Business is committed to the principle of equality
                  regardless of age, disability, gender reassignment, marriage
                  or civil partnership, pregnancy or maternity, race, religion
                  or belief and sex or sexual orientation. Policies will be
                  applied that are fair, equitable and consistent with skills
                  and abilities. The Agency Worker has a duty to support the
                  Employment Business in implementing these policies to ensure
                  equality of opportunity. 13. COMPLAINING ABOUT DISCRIMINATION
                  OR HARASSMENT 13.1 If the Agency Worker believes that they are
                  or have been the victim of minor discrimination or harassment,
                  they should first make it clear to the discriminator/harasser
                  that their behaviour is unwelcome and politely ask them to
                  stop. If they feel unable to do this, or if this approach
                  fails, or if the discrimination/harassment is more serious,
                  they should discuss the matter with a senior member of staff
                  at the Employment Business, who will endeavour to resolve the
                  situation on their behalf. 14. INTELLECTUAL PROPERTY RIGHTS
                  14.1 The Agency Worker acknowledges that all copyright,
                  trademarks, patents, and other intellectual property rights
                  deriving from services carried out by them for the Client
                  during the Assignment shall belong to the Client. Accordingly,
                  the Agency Worker shall execute all such documents and do all
                  such acts as the Employment Business shall from time to time
                  require to give effect to its rights pursuant to this Clause.
                  15. CONFIDENTIALITY 15.1 The Agency Worker may become privy to
                  the Confidential Information of the Employment Business or the
                  Client at which the Agency Worker works on Assignment. 15.2 In
                  order to protect the confidentiality and trade secrets of any
                  Client and the Employment Business and without prejudice to
                  every other duty to keep secret all information given to it or
                  gained in confidence the Agency Worker agrees as follows: (a)
                  Unless required to do so in the proper performance of their
                  duties, not to divulge or communicate to any person, use for
                  any purposes other than those of the Employment Business or,
                  as appropriate, any Client, or cause any unauthorised
                  disclosure, through any failure to exercise due care and
                  attention, of any Confidential Information relating to the
                  Employment Business or any Client. (b) To deliver up to the
                  Client or the Employment Business (as directed) at the end of
                  each Assignment all documents and other materials belonging to
                  the Client (and all copies) which are in their possession
                  including documents and other materials created by them during
                  the course of an Assignment. (c) Not at any time to make any
                  copy, abstract, summary or précis of the whole or any part of
                  any document or other material belonging to the Client except
                  when required to do so in the course of their duties under an
                  Assignment in which event any such item shall belong to the
                  Client or the Employment Business as appropriate. 16. DATA
                  PROTECTION 16.1 The Agency Worker acknowledges that the
                  Employment Business must process personal data about them in
                  order to properly fulfil its obligations under these Terms and
                  as otherwise required by law in relation to their engagement
                  in accordance with the Data Protection Laws. 16.2 By signing
                  these Terms, the Agency Worker acknowledges and agrees that
                  the Employment Business is permitted to hold personal
                  information about them as part of its personnel and other
                  business records and may use such information in its
                  operations. The Agency Worker agrees that the Employment
                  Business may disclose such information to third parties in the
                  event that such disclosure is, in its view, required for the
                  proper conduct of the Employment Businesses operations or that
                  of any associated company. 16.3 In the event that the
                  Employment Business needs to process any sensitive personal
                  data or pass any sensitive personal data on to a third party,
                  they will contact the Agency Worker to obtain their specific
                  consent. 16.4 The Agency Worker warrants that in relation to
                  these Terms, they shall comply strictly with all provisions
                  applicable to them under the Data Protection Laws and shall
                  not do or permit to be done anything which might cause the
                  Employment Business or the Client to breach any Data
                  Protection Laws. 17. SEVERABILITY 17.1 If any of the
                  provisions of these Terms shall be determined by any competent
                  authority to be unenforceable to any extent, such provision
                  shall, to that extent, be severed from the remaining Terms,
                  which shall continue to be valid to the fullest extent
                  permitted by applicable laws. 18. RIGHTS OF THIRD PARTIES 18.1
                  None of the provisions of these Terms are intended to be for
                  the benefit of or enforceable by third parties and the
                  operation of the Contracts (Rights of Third Parties) Act 1999
                  is excluded. 19. NOTICES 19.1 All notices which are required
                  to be given in accordance with this Agreement shall be in
                  writing and may be delivered personally or by first class
                  prepaid post to the registered office of the party upon whom
                  the notice is to be served or any other address that the party
                  has notified the other party of in writing, by email or
                  facsimile transmission. Any such notice shall be deemed to
                  have been served: if by hand when delivered; if by first class
                  post 48 hours following posting; and if by email or facsimile
                  transmission when that email or facsimile is sent. 20.
                  GOVERNING LAW AND JURISDICTION 20.1 These Terms are governed
                  by the law of England and Wales and are subject to the
                  exclusive jurisdiction of the Courts of England and Wales.
                  Signed for and on behalf of the Employment Business, Rapid Resourcing Limited Signed …………(Will use the sign
                  from below box)…………… Dated{" "}
                  {moment(new Date(currentDocument?.signDate)).format("DD-MM-YYYY")}. I, the Agency
                  Worker confirm that I have read and understand the above Terms
                  and agree to my personal details being retained by the
                  Employment Business for the purpose of matching me with
                  suitable Clients, contacting me with offers of ad hoc work
                  Assignments and arranging payment for work carried out. I
                  understand that this engagement, and any future work
                  Assignments will not indicate an employment relationship
                  between the Employment Business and myself.<br />
                        FullName: {currentDocument?.firstName}{" "}
                        {currentDocument?.surName}
                      </strong>
                    </li>
                    <li className="list-group-item d-flex">
                      <div className="row">
                        <div className="col-12">
                          {currentDocument?.signature && (
                            <img
                              width={100}
                              src={`${currentDocument?.signature}?${sasToken}`}
                              alt="Signature"
                            />
                          )}
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item d-flex">
                      Sign Date:{" "}
                      {moment(currentDocument?.signDate).format("DD-MM-YYYY")}
                    </li>
                  </ul>
                </div>
              </div>
            )}
          </Box>
        </>
      ) : (
        <>
          <Nav variant="pills" className="justify-content-center mb-3">
            <Nav.Item>
              <Nav.Link
                className={step === 1 ? "text-light" : ""}
                active={step === 1}
              >
                Step 1
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className={step === 2 ? "text-light" : ""}
                active={step === 2}
              >
                Step 2
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <ProgressBar now={progress} className="mb-4" />

          <Form onSubmit={handleSubmit}>
            {step === 1 && (
              <div>
                <h3>Section 1: Personal Information</h3>
                <Form.Group className="mb-3">
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    isInvalid={!!errors.title}
                    required
                  />
                  {errors.title && (
                    <Alert variant="danger">{errors.title}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    isInvalid={!!errors.firstName}
                    required
                  />
                  {errors.firstName && (
                    <Alert variant="danger">{errors.firstName}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Surname</Form.Label>
                  <Form.Control
                    type="text"
                    name="surName"
                    value={formData.surName}
                    onChange={handleChange}
                    isInvalid={!!errors.surName}
                    required
                  />
                  {errors.surName && (
                    <Alert variant="danger">{errors.surName}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Type of work (cleaner, warehouse etc)</Form.Label>
                  <Form.Control
                    type="text"
                    name="typeOfWork"
                    value={formData.typeOfWork}
                    onChange={handleChange}
                    isInvalid={!!errors.typeOfWork}
                    required
                  />
                  {errors.typeOfWork && (
                    <Alert variant="danger">{errors.typeOfWork}</Alert>
                  )}
                </Form.Group>
                <p style={{ textAlign: "justify" }}>
                  TERMS OF ENGAGEMENT FOR TEMPORARY AGENCY WORKERS (Contract for
                  Services) AGENCY WORKER NAME IN FULL: TYPE OF WORK TO BE
                  PROVIDED: 1. DEFINITIONS 1.1 In these Terms of Engagement, the
                  following definitions apply: “Agency Worker” means the person
                  named above; “Assignment” means the period during which the
                  Agency Worker is supplied to provide services to the Client.
                  Each Assignment will end when the Agency Worker ceases to be
                  supplied to the Client or when the Agency Worker is no longer
                  available for work; “Assignment Schedule” means written
                  confirmation of the assignment details to be given to the
                  Agency Worker upon acceptance of the Assignment; “AWR” means
                  the Agency Workers Regulations 2010; “Client” means the
                  person, firm, or corporate body together with any subsidiary
                  or associated person, firm, or corporate body (as the case may
                  be) to whom or which the Agency Worker is supplied or
                  introduced; “Conduct Regulations” means the Conduct of
                  Employment Agencies and Employment Businesses Regulations
                  2003; “Confidential Information” means any and all
                  confidential commercial, financial, marketing, technical or
                  other information or data of whatever nature relating to the
                  Client or Employment Business or their business or affairs
                  (including but not limited to these Terms; data, records,
                  reports, agreements, software, programs, specifications,
                  knowhow, trade secrets and other information concerning the
                  Assignment) in any form or medium whether disclosed or granted
                  access to whether in writing, orally or by any other means,
                  provided to the Agency Worker or any third party in relation
                  to the Assignment by the Client or the Employment Business or
                  by a third party on behalf of the Client whether before or
                  after the date of these Terms together with any reproductions
                  of such information in any form or medium or any part(s) of
                  such information; “Employment Business” means Rapid Resourcing LIMITED registered in the UK under registration
                  number 05757489 whose registered office is at C/O Henry
                  Diaper, Lees Road, Knowsley Industrial Park, Liverpool,
                  Merseyside, L33 7SE; “Relevant Period” means the later of: (a)
                  the period of eight weeks commencing on the day after the last
                  day on which the Agency Worker worked for the Client having
                  been supplied by the Employment Business; or (b) the period of
                  fourteen weeks commencing on the first day on which the Agency
                  Worker worked for the Client having been supplied by the
                  Employment Business; or (c) Fourteen weeks from the first day
                  of the most recent Assignment where there has been a break of
                  more than six weeks (forty-two days) since any previous
                  Assignment; “Terms” means the terms and conditions set out
                  herein together with any Assignment Schedule to these Terms.
                  1.2 Unless the context otherwise requires, references to the
                  singular include the plural and references to the masculine
                  include the feminine and vice versa. 1.3 The headings
                  contained in these Terms are for convenience only and do not
                  affect their interpretation. 2. THE CONTRACT 2.1 These Terms
                  constitute a Contract for Services between the Employment
                  Business and the Agency Worker, and they govern all
                  Assignments undertaken by the Agency Worker. No Contract shall
                  exist between the Employment Business and the Agency Worker
                  between Assignments. These Terms shall prevail over any other
                  Terms put forward by the Agency Worker. 2.2 For the avoidance
                  of doubt, the Agency Worker is not an employee of the
                  Employment Business although the Employment Business is
                  required to make deductions from the Agency Worker's pay in
                  accordance with Clause 7.1. These Terms shall not give rise to
                  a Contract of Employment between the Employment Business and
                  the Agency Worker, or the Agency Worker and the Client. The
                  Agency Worker is supplied as a Worker, and is entitled to
                  certain statutory rights as such, but nothing in these Terms
                  shall be construed as giving the Agency Worker rights in
                  addition to those provided by statute except where expressly
                  stated. 2.3 No variation or alteration of these Terms shall be
                  valid unless approved by the Employment Business in writing
                  and signed by both parties. 2.4 The Employment Business shall
                  act as an Employment Business (as defined in Section 13(3) of
                  the Employment Agencies Act 1973) (as amended) when
                  introducing or supplying the Agency Worker for Assignments
                  with its Clients. 3. ASSIGNMENTS 3.1 The Employment Business
                  will endeavour to obtain suitable Assignments for the Agency
                  Worker in the capacity detailed above. 3.2 The Agency Worker
                  shall not be obliged to accept any Assignment offered by the
                  Employment Business, and the Employment Business shall incur
                  no liability to the Agency Worker should it fail to offer
                  opportunities to work in the capacity detailed above or in any
                  other capacity. 3.3 The Agency Worker acknowledges that the
                  nature of temporary work means that there may be periods when
                  no suitable work is available and agrees that suitability
                  shall be determined solely by the Employment Business. 3.4 The
                  Agency Worker is free to engage in other work, however if they
                  have already carried out or are considering any additional
                  work, they should notify the Employment Business so that any
                  implications arising from the current Working Time Legislation
                  can be discussed. 3.5 For the purpose of calculating the
                  average number of weekly hours worked by the Agency Worker on
                  an Assignment, the start date for the relevant averaging
                  period under the Working Time Regulations 1998 shall be the
                  date on which the Agency Worker commences the first
                  Assignment. 3.6 If during the course of an Assignment or
                  during the Relevant Period at the end of an Assignment the
                  Client wishes to employ the Agency Worker direct, the Agency
                  Worker acknowledges that the Employment Business will be
                  entitled either to charge the Client an introduction fee or to
                  agree an extension of the hiring period with the Client at the
                  end of which the Agency Worker may be employed direct by the
                  Client without further charge. 4. EMPLOYMENT BUSINESS
                  OBLIGATIONS 4.1 At the same time as an Assignment is offered
                  to the Agency Worker, which may be on an hourly, daily,
                  weekly, or other basis, the Employment Business shall inform
                  the Agency Worker of the identity of the Client and if
                  applicable, the nature of their business; the date the work is
                  to commence and the duration or likely duration of the work;
                  the type of work, location and hours during which the Agency
                  Worker would be required to work; the rate of remuneration
                  that will be paid and any expenses payable by or to the Agency
                  Worker; and any risks to health and safety known to the Client
                  in relation to the Assignment and the steps the Client has
                  taken to prevent or control such risks. In addition, the
                  Employment Business shall inform the Agency Worker what
                  experience, training, and qualifications the Client considers
                  necessary to work on the Assignment and of any authorisation
                  required by law or a professional body to work on the
                  Assignment. 4.2 Where such information is not given in paper
                  form or by electronic means it shall be confirmed by such
                  means by the end of the third business day following
                  (excluding Saturday, Sunday and any public or Bank Holidays).
                  4.3 If a variation to the Assignment Schedule is agreed
                  between the Agency Worker and the Employment Business, the
                  Agency Worker shall be provided with a copy of the Assignment
                  Schedule confirming the agreed variation by no later than five
                  business days following the day on which the variation was
                  agreed. 4.4 An Assignment Schedule may not be provided by the
                  Employment Business to the Agency Worker under the following
                  circumstances: (a) Where the Agency Worker is being offered an
                  Assignment in the same position that they have undertaken
                  within the previous five working days and the Assignment
                  Schedule has already been provided to the Agency Worker; or
                  (b) Where the Assignment is intended to last for five
                  consecutive working days or less and the Agency Worker has
                  previously received the Assignment Schedule on which the
                  details remain the same. In such situation the Employment
                  Business need only provide written confirmation of the
                  identity of the Client and the likely duration of the
                  Assignment. Where the Assignment subsequently extends past the
                  five working days, the Agency Worker shall be provided with an
                  Assignment Schedule within eight days from the start of the
                  Assignment. 4.5 The Employment Business will ensure that the
                  Agency Worker receives any rights in relation to basic
                  employment and working conditions to which they are entitled
                  to under Regulation 5 of the AWR once the Agency Worker has
                  completed the qualifying period (currently the Agency Worker
                  must work in the same role with the same Client for twelve
                  continuous calendar weeks, during one or more Assignments).
                  4.6 In accordance with Regulation 12 of the AWR, the
                  Employment Business will ensure that unless less favourable
                  treatment is justified on objective grounds, the Agency Worker
                  is treated no less favourably than a comparable worker in
                  relation to the collective facilities and amenities (which are
                  defined as canteen or other similar facilities, child care
                  facilities and transport services) provided by the Client. 4.7
                  In accordance with Regulation 13 of the AWR, the Employment
                  Business will ensure that during the Assignment the Agency
                  Worker is informed of any relevant vacant posts with the
                  Client to give the Agency Worker the same opportunity as a
                  comparable worker to find permanent employment with the
                  Client. 5. AGENCY WORKERS OBLIGATIONS 5.1 The Agency Worker
                  shall during every Assignment and afterwards where
                  appropriate: (a) Co-operate with the Client's reasonable
                  instructions and accept the direction and supervision of any
                  responsible person in the Client’s organisation; (b) Make
                  themselves available to the Client for no less than the
                  minimum working hours (the Assignment Work Pattern), shown on
                  the provided Assignment Schedule; (c) Familiarise themself
                  with and observe any relevant rules and regulations of the
                  Client's establishment to which attention has been drawn or
                  which the Agency Worker might reasonably be expected to
                  ascertain (including but not limited to rules surrounding
                  normal hours of work and the use of any computer equipment,
                  Client telephones and personal mobile phones); (d) Take all
                  reasonable steps to safeguard their own health and safety and
                  that of any other person who may be present or be affected by
                  their actions on the Assignment and comply with the Health and
                  Safety policies and procedures of the Client; (e) Report any
                  accident or incident that occurs whilst on an Assignment to
                  the Client and ensure that it is entered into the Client’s
                  Accident Book; (f) Not operate any vehicle, plant, or
                  machinery without prior agreement between and subsequent
                  authorisation from the Employment Business and the Client; (g)
                  Not engage in any conduct detrimental to the interests of the
                  Client or the Employment Business including any conduct from
                  the Agency Worker reasonably likely to be detrimental to the
                  Client's custom or business and their reputation; (h) Conduct
                  themselves in a professional manner and dress according to
                  Client requirements. Where no specific instructions have been
                  given, a professional image should be maintained and clothes
                  appropriate to the responsibilities of the Assignment worn
                  along with any form of identification required. All applicable
                  laws in this respect need to be abided by; (i) At the end of
                  the Assignment or when directed, return to the Employment
                  Business, all property of the Employment Business or Client
                  including but not limited to all equipment, materials,
                  documents, personal protective equipment, clothing, and safety
                  boots; (j) Not at any time divulge to any person, nor use for
                  their own or any other person's benefit, any Confidential
                  Information relating to the Client's or the Employment
                  Businesses' employees, customers, business affairs,
                  transactions, or finances. 5.2 If the Agency Worker is unable
                  for any reason to attend work during an Assignment, they
                  should inform the Employment Business at the first possible
                  opportunity, but in any event at least two hours prior to the
                  commencement of the Assignment or shift. Where contact to the
                  Employment Business is not possible the Agency Worker is
                  required to contact the Client. 5.3 Where the Agency Worker
                  becomes aware of any reason why they may not be suitable for
                  an Assignment either before the commencement of or during the
                  Assignment they should notify the Employment Business
                  immediately. 5.4 By commencing an Assignment, the Agency
                  Worker acknowledges that they are not aware of anything which
                  will cause a detriment to the Employment Business and/or the
                  interests of the Client by being engaged in such an
                  Assignment. The Agency Worker shall inform the Employment
                  Business immediately if they become aware of any circumstances
                  which might affect the Client's willingness to accept their
                  services. 5.5 The Agency Worker warrants that all information
                  provided to the Employment Business in regard to their right
                  to work in the UK, experience, training and qualifications,
                  which may be required or considered by any professional body
                  when determining whether to engage the Agency Workers
                  services, or which are required by law, is true and compliant.
                  5.6 Prior to the commencement of the Assignment, the Agency
                  Worker shall notify the Employment Business if the Client is a
                  previous employer whether this be directly or via another
                  Employment Business or third party and will provide details of
                  when and in what role(s), including details of any breaks
                  between periods of work, and the reasons for such breaks. 5.7
                  If the Agency Worker considers that they have not or may not
                  have received equal treatment under the AWR, the Agency Worker
                  should discuss this with the Employment Business or raise this
                  in writing with the Employment Business setting out as fully
                  as possible the basis of their concerns. 5.8 The Agency Worker
                  acknowledges that any breach of their obligations under this
                  Clause may cause the Employment Business to suffer loss and
                  they agree that the Employment Business reserves the right to
                  make a claim for damages to recover such losses from the
                  Agency Worker. 6. TIMESHEETS 6.1 At the end of each week of an
                  Assignment (or at the end of the Assignment where it is for a
                  period of one week or less or is completed before the end of a
                  week) the Agency Worker shall deliver to the Employment
                  Business their time sheet duly completed to indicate the
                  number of hours worked by them during the preceding week (or
                  such lesser period) and signed by an authorised representative
                  of the Client. 6.2 Subject to Clause 6.3 the Employment
                  Business shall pay the Agency Worker for all hours worked
                  regardless of whether the Employment Business has received
                  payment from the Client for these hours. 6.3 Failure to submit
                  a properly completed or authorised timesheet for hours worked
                  may delay payment for those hours. 6.4 Deliberate
                  misrepresentation by an Agency Worker on a timesheet of the
                  hours worked, if proven following investigation, will be
                  handled as fraud. 6.5 For the avoidance of doubt and for the
                  purposes of the Working Time Regulations 1998, the Agency
                  Worker's working time shall only consist of those periods
                  during which they are carrying out their activities or duties
                  for the Client as part of the Assignment. Subject to any
                  amendments made to the Agency Worker's basic working
                  conditions during the term of this Agreement in compliance
                  with Regulation 5 of the AWR, time spent travelling to the
                  Client's premises, lunch breaks and other rest breaks shall
                  not count as part of the Agency Worker's working time for
                  these purposes. 7. REMUNERATION 7.1 The Employment Business
                  shall pay to the Agency Worker remuneration of the current
                  National Minimum Wage or National Living Wage (where
                  applicable), or above. The actual rate will be notified on a
                  per Assignment basis, for each hour worked during an
                  Assignment, subject to deductions in respect of PAYE pursuant
                  to Section 44-47 of the Income Tax (Earnings and Pensions) Act
                  2003 and Class 1 National Insurance Contributions and any
                  other deductions which the Employment Business may be required
                  by law to make. 7.2 Payment will be made weekly in arrears
                  directly into the Agency Workers nominated bank account on
                  Friday of each week in respect of the hours worked in the
                  preceding week. Any queries regarding payment should be raised
                  with the Employment Business. 7.3 The Agency Worker may by
                  virtue of having completed the qualifying period for an
                  Assignment be entitled under the AWR to an increase in their
                  pay and other benefits and any such variation will be notified
                  to the Agency Worker in the Assignment Schedule. 7.4 Subject
                  to any statutory entitlement under the relevant legislation
                  referred to in Clauses 8 and 9 below and any other statutory
                  requirement, the Agency Worker is not entitled to receive
                  payment from the Employment Business or Client for time not
                  spent on Assignment, whether in respect of holidays, illness
                  or absence for any other reason, unless otherwise agreed. 7.5
                  Subject to compliance with Regulation 12 of the Conduct
                  Regulations, the Employment Business reserves the right in its
                  absolute discretion to deduct from the Agency Worker’s pay any
                  sums which they may owe the Employment Business including,
                  without limitation, any overpayments, loans or advances made
                  to the Agency Worker by the Employment Business or any losses
                  suffered by the Employment Business as a result of the Agency
                  Workers negligence or breach of either the Employment
                  Business’s or the Client’s rules. If the Agency Worker’s final
                  payment is insufficient to allow for the whole amount of any
                  deduction, they will be required to repay any outstanding
                  amount due to the Employment Business within the terms agreed.
                  7.6 The Employment Business reserves the right to deduct the
                  cost of any speeding or parking fines from the Agency Workers
                  remuneration if it can be proved that they were allocated the
                  vehicle when the fine was incurred. 8. STATUTORY LEAVE 8.1
                  Subject to any increased entitlement pursuant to the AWR, the
                  Agency Worker is entitled to paid annual leave for time worked
                  during an Assignment according to the statutory minimum as
                  amended occasionally. 8.2 The current statutory minimum
                  entitlement to paid annual leave is 5.6 weeks inclusive of
                  Bank Holidays. All entitlement to leave must be taken during
                  the Leave Year in which it accrues, and none may be carried
                  forward to the next year. 8.3 Under the AWR, on completion of
                  the qualifying period the Agency Worker may be entitled to
                  paid and/or unpaid annual leave in addition to the Agency
                  Worker's entitlement to paid annual leave under the Working
                  Time Regulations and in accordance with Clauses 8.1 and 8.2.
                  If this is the case, any such entitlement(s), the date from
                  which any such entitlement(s) will commence and how payment
                  for such entitlement(s) accrue will be set out in the relevant
                  Assignment Schedule. 8.4 The Leave Year is the annual period
                  during which the Agency Worker accrues and may take statutory
                  leave and runs from 01 January to 31 December. The Agency
                  Worker is responsible for ensuring that all paid annual leave
                  is requested and taken within the Leave Year. 8.5 Entitlement
                  to payment for leave accrues in proportion to the amount of
                  time worked continuously by the Agency Worker on Assignment
                  during the Leave Year and is paid in accordance with the
                  Working Time Regulations. Annual leave does not accrue for any
                  time when the Agency Worker is not working on Assignment. 8.6
                  Subject to Clause 8.3, the amount of payment which the Agency
                  Worker will receive in respect of periods of annual leave
                  taken during the course of an Assignment will be calculated in
                  accordance with and paid in proportion to the number of days
                  which the Agency Worker has worked on Assignment. 8.7 Subject
                  to Clause 8.3, in the course of any Assignment during the
                  first Leave Year, the Agency Worker is entitled to request and
                  receive paid leave at the rate of one-twelfth of the Agency
                  Worker's total holiday entitlement in each month of the Leave
                  Year. 8.8 Where the Agency Worker wishes to take any leave to
                  which they are entitled, they should put the request in
                  writing to admin@rapidresourcingltd.co.uk advising of the dates
                  of their intended absence. The amount of notice, which the
                  Agency Worker is required to give, is a minimum of four weeks
                  to take a weeks’ holiday or a minimum of one week to take a
                  single day. The Agency Worker should also notify the Client of
                  their intended absence. 8.9 The Employment Business will
                  allocate agreed leave dates to take account of business needs
                  and the arrangements made by other Agency Workers and or
                  Clients own employees to ensure operational efficiency. The
                  Employment Business reserves the right to refuse leave
                  requests if they conflict with the needs of the business and
                  may, with due notice, require that the Agency Worker takes
                  their annual leave on specified dates. 8.10 Where a Bank
                  Holiday or other public holiday falls during an Assignment and
                  the Agency Worker does not work on that day, the day may be
                  taken as part of the Agency Worker's paid annual leave
                  entitlement. 8.11 Where this Contract is terminated by either
                  party and a P45 is requested, the Agency Worker shall be
                  entitled to a payment in lieu of any untaken leave where the
                  amount of leave taken is less than the amount accrued in
                  accordance with Clause 8.5 above. Where the Agency Worker has
                  taken more leave than has been accrued pro-rata, the
                  appropriate deductions will be made from their final payment.
                  9. SICKNESS ABSENCE 9.1 The Agency Worker may be eligible for
                  Statutory Sick Pay if they meet the relevant statutory
                  criteria. 9.2 The Agency Worker is required to provide
                  evidence of incapacity to work to the Employment Business, by
                  way of a self-certification form for the first seven days of
                  incapacity and a doctor's/hospital certificate thereafter. 9.3
                  For the purposes of the Statutory Sick Pay scheme the
                  qualifying days for entitlement to payment are the days on
                  which the Agency Worker is due to work on an Assignment. There
                  will be no entitlement to Statutory Sick Pay when the Agency
                  Worker was not due to work on Assignment. Statutory Sick Pay
                  is not payable for the first three qualifying days in a period
                  of incapacity for work. 9.4 In the event that the Agency
                  Worker submits a Statement of Fitness for Work or similar
                  medical evidence, which indicates that the Agency Worker may,
                  subject to certain conditions be fit to work/return to work,
                  the Employment Business will in its absolute discretion
                  determine whether the Agency Worker will be: (a) placed in a
                  new Assignment; or (b) permitted to continue with the ongoing
                  Assignment. In making such determination, the Employment
                  Business may consult with the Client and Agency Worker as
                  appropriate to assess whether the conditions identified in the
                  Statement or similar documentation can be satisfied for the
                  duration of the Assignment. 10. PENSION 10.1 The Employment
                  Business will comply with the pension duties in respect of the
                  Agency Worker in accordance with Part 1 of the Pensions Act
                  2008. 11. TERMINATION 11.1 The Employment Business or the
                  Client may terminate the Agency Workers Assignment at any time
                  without prior notice or liability. 11.2 The Agency Worker is
                  required to give one weeks’ notice to terminate an Assignment
                  to enable a replacement to be found (unless the Assignment is
                  for a shorter period, in which case the Agency Worker must
                  work to the end of the agreed Assignment period). 11.3
                  Continuation of an Assignment is subject to continuation of
                  the Contract between the Employment Business and the Client.
                  In the event that this is terminated for any reason, the
                  Assignment will cease with immediate effect without liability
                  to the Agency Worker, with the exception of hours worked by
                  the Agency Worker up to the date of termination of the
                  Assignment. 11.4 If the Agency Worker does not inform the
                  Client or the Employment Business (in accordance with Clause
                  5.2) should they be unable to attend work during the course of
                  an Assignment this will be treated as termination of the
                  Assignment by the Agency Worker in accordance with Clause 11.2
                  unless the Agency Worker can show that exceptional
                  circumstances prevented them from complying with Clause 5.2.
                  11.5 If the Agency Worker is absent during the course of an
                  Assignment and the Contract has not been otherwise terminated,
                  the Employment Business will be entitled to terminate the
                  Contract in accordance with Clause 11.1 if the work to which
                  the Agency Worker was assigned is no longer available. 11.6 If
                  the Agency Worker does not report to the Employment Business
                  to notify their availability for work for a period of three
                  weeks, the Employment Business will forward their P45 to their
                  last known address. 12. EQUAL OPPORTUNITIES 12.1 The
                  Employment Business is committed to the principle of equality
                  regardless of age, disability, gender reassignment, marriage
                  or civil partnership, pregnancy or maternity, race, religion
                  or belief and sex or sexual orientation. Policies will be
                  applied that are fair, equitable and consistent with skills
                  and abilities. The Agency Worker has a duty to support the
                  Employment Business in implementing these policies to ensure
                  equality of opportunity. 13. COMPLAINING ABOUT DISCRIMINATION
                  OR HARASSMENT 13.1 If the Agency Worker believes that they are
                  or have been the victim of minor discrimination or harassment,
                  they should first make it clear to the discriminator/harasser
                  that their behaviour is unwelcome and politely ask them to
                  stop. If they feel unable to do this, or if this approach
                  fails, or if the discrimination/harassment is more serious,
                  they should discuss the matter with a senior member of staff
                  at the Employment Business, who will endeavour to resolve the
                  situation on their behalf. 14. INTELLECTUAL PROPERTY RIGHTS
                  14.1 The Agency Worker acknowledges that all copyright,
                  trademarks, patents, and other intellectual property rights
                  deriving from services carried out by them for the Client
                  during the Assignment shall belong to the Client. Accordingly,
                  the Agency Worker shall execute all such documents and do all
                  such acts as the Employment Business shall from time to time
                  require to give effect to its rights pursuant to this Clause.
                  15. CONFIDENTIALITY 15.1 The Agency Worker may become privy to
                  the Confidential Information of the Employment Business or the
                  Client at which the Agency Worker works on Assignment. 15.2 In
                  order to protect the confidentiality and trade secrets of any
                  Client and the Employment Business and without prejudice to
                  every other duty to keep secret all information given to it or
                  gained in confidence the Agency Worker agrees as follows: (a)
                  Unless required to do so in the proper performance of their
                  duties, not to divulge or communicate to any person, use for
                  any purposes other than those of the Employment Business or,
                  as appropriate, any Client, or cause any unauthorised
                  disclosure, through any failure to exercise due care and
                  attention, of any Confidential Information relating to the
                  Employment Business or any Client. (b) To deliver up to the
                  Client or the Employment Business (as directed) at the end of
                  each Assignment all documents and other materials belonging to
                  the Client (and all copies) which are in their possession
                  including documents and other materials created by them during
                  the course of an Assignment. (c) Not at any time to make any
                  copy, abstract, summary or précis of the whole or any part of
                  any document or other material belonging to the Client except
                  when required to do so in the course of their duties under an
                  Assignment in which event any such item shall belong to the
                  Client or the Employment Business as appropriate. 16. DATA
                  PROTECTION 16.1 The Agency Worker acknowledges that the
                  Employment Business must process personal data about them in
                  order to properly fulfil its obligations under these Terms and
                  as otherwise required by law in relation to their engagement
                  in accordance with the Data Protection Laws. 16.2 By signing
                  these Terms, the Agency Worker acknowledges and agrees that
                  the Employment Business is permitted to hold personal
                  information about them as part of its personnel and other
                  business records and may use such information in its
                  operations. The Agency Worker agrees that the Employment
                  Business may disclose such information to third parties in the
                  event that such disclosure is, in its view, required for the
                  proper conduct of the Employment Businesses operations or that
                  of any associated company. 16.3 In the event that the
                  Employment Business needs to process any sensitive personal
                  data or pass any sensitive personal data on to a third party,
                  they will contact the Agency Worker to obtain their specific
                  consent. 16.4 The Agency Worker warrants that in relation to
                  these Terms, they shall comply strictly with all provisions
                  applicable to them under the Data Protection Laws and shall
                  not do or permit to be done anything which might cause the
                  Employment Business or the Client to breach any Data
                  Protection Laws. 17. SEVERABILITY 17.1 If any of the
                  provisions of these Terms shall be determined by any competent
                  authority to be unenforceable to any extent, such provision
                  shall, to that extent, be severed from the remaining Terms,
                  which shall continue to be valid to the fullest extent
                  permitted by applicable laws. 18. RIGHTS OF THIRD PARTIES 18.1
                  None of the provisions of these Terms are intended to be for
                  the benefit of or enforceable by third parties and the
                  operation of the Contracts (Rights of Third Parties) Act 1999
                  is excluded. 19. NOTICES 19.1 All notices which are required
                  to be given in accordance with this Agreement shall be in
                  writing and may be delivered personally or by first class
                  prepaid post to the registered office of the party upon whom
                  the notice is to be served or any other address that the party
                  has notified the other party of in writing, by email or
                  facsimile transmission. Any such notice shall be deemed to
                  have been served: if by hand when delivered; if by first class
                  post 48 hours following posting; and if by email or facsimile
                  transmission when that email or facsimile is sent. 20.
                  GOVERNING LAW AND JURISDICTION 20.1 These Terms are governed
                  by the law of England and Wales and are subject to the
                  exclusive jurisdiction of the Courts of England and Wales.
                  Signed for and on behalf of the Employment Business, Rapid Resourcing Limited Signed …………(Will use the sign
                  from below box)…………… Dated{" "}
                  {moment(new Date()).format("DD-MM-YYYY")}. I, the Agency
                  Worker confirm that I have read and understand the above Terms
                  and agree to my personal details being retained by the
                  Employment Business for the purpose of matching me with
                  suitable Clients, contacting me with offers of ad hoc work
                  Assignments and arranging payment for work carried out. I
                  understand that this engagement, and any future work
                  Assignments will not indicate an employment relationship
                  between the Employment Business and myself.
                  <br />
                  Dated: {moment(new Date()).format("DD-MM-YYYY")}
                </p>
                {/* <Form.Group className="mb-3">
              <Form.Control
                type="date"
                name="signedDate"
                value={formData.signedDate}
                onChange={handleChange}
              />
            </Form.Group> */}
                <Form.Group className="mb-3">
                  <Form.Label>Signed:</Form.Label>
                  <div className="signature-pad">
                    <SignaturePad
                      ref={documentSigPadRef}
                      penColor="black"
                      canvasProps={{ className: "signature-canvas" }} // Customize the canvas appearance
                    />
                  </div>
                  {errors.documentSignature && (
                    <Alert variant="danger">{errors.documentSignature}</Alert>
                  )}
                  <Button
                    variant="secondary"
                    onClick={clearDocumentSignature}
                    className="mt-2"
                  >
                    Clear Signature
                  </Button>
                </Form.Group>
                <Button variant="primary" onClick={nextStep}>
                  Next
                </Button>
              </div>
            )}

            {step === 2 && (
              <div>
                <h3>Step 2: Sign and Submit</h3>
                <p>
                  By signing this page, I confirm that I fully understand the
                  content and agree to adhere to it at all times. I also agree
                  that all the details provided in this document are accurate
                  and complete to the best of my knowledge.
                </p>
                {/* Signature Pad Section */}
                <Form.Group className="mb-3">
                  <Form.Label>Signature</Form.Label>
                  <div className="signature-pad">
                    <SignaturePad
                      ref={sigPadRef}
                      penColor="black"
                      canvasProps={{ className: "signature-canvas" }} // Customize the canvas appearance
                    />
                  </div>
                  {errors.signature && (
                    <Alert variant="danger">{errors.signature}</Alert>
                  )}
                  <Button
                    variant="secondary"
                    onClick={clearSignature}
                    className="mt-2"
                  >
                    Clear Signature
                  </Button>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    name="consent"
                    label="Clear By ticking this box I consent to the company processing my
                data and the evidence of this document being stored within their
                system for the purpose of work finding services."
                    checked={formData.consent} // Use checked for checkboxes
                    onChange={handleChange}
                    isInvalid={!!errors.consent}
                  />
                  {errors.consent && (
                    <Alert variant="danger">{errors.consent}</Alert>
                  )}
                </Form.Group>
                <Button variant="secondary" onClick={prevStep} className="me-2">
                  Previous
                </Button>
                <Button variant="success" type="submit">
                  Submit
                </Button>
              </div>
            )}
          </Form>
        </>
      )}
    </Container>
  );
};

const mapStateToProps = (state) => ({
  currentDocument: state.user.currentDocument,
  documentList: state.user.documentList,
  user: state.user.loggedInUserData,
  sasToken: state.user.sasToken,
  ipAddress: state.user.ipAddress,
});
export default connect(mapStateToProps, { getSasToken })(
  LfukRecruitmentServicesLimitedTermsOfEngagement
);
